import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { GrievanceServicesService } from './__grievance-services/grievance-services.service';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/internal/operators/map';

@Component({
  selector: 'app-grievance',
  templateUrl: './grievance.component.html',
  styleUrls: ['./grievance.component.scss'],
})
export class GrievanceComponent  implements OnInit {
  today = new Date();
  // viewAddressGrievance = false;  
  selectedTabIndex!: string;
  
  grievanceTable!: {
    tableHeaders: { [key:string]: { name: string, showInTable: boolean, index: string} },
    tableData: {
      [key: string]: string | null | any
    }[]
  };
  
  constructor(public dialog: MatDialog, public mobileResponsiveService: MobileResponsiveService, private getCompanyAndUsersData: GetCompanyAndUsersData, public grievanceServicesService: GrievanceServicesService, public toastr: ToastrService) { }
  
  ngOnInit() {
    this.grievanceTable = {
      tableHeaders: { 
        srNo: { name: 'Sr no', showInTable: true, index: '01' }, 
        grievanceType: { name: 'Grievance Type', showInTable: true, index: '02' },
        againstWhom: { name: 'Against Whom', showInTable: true, index: '03' },
        whomToSent: { name: 'Whom To Sent', showInTable: true, index: '04' },
        raisedDate: { name: 'Raised Date', showInTable: true, index: '05' },
        priority: { name: 'Priority', showInTable: true, index: '06' },
        reason: { name: 'Reason', showInTable: true, index: '07' },
        commentFromReceiver: { name: 'Comment From Receiver', showInTable: true, index: '08' },
        status: { name: 'Status', showInTable: true, index: '09' },
        resolvedDate: { name: 'Resolved Date', showInTable: true, index: '10' },
        editDelete: { name: 'Edit / Delete', showInTable: true, index: '11' }
      },
      tableData: []
    };
    
    this.onTabChange('Grievance'); 
  }
  
  
  onTabChange(event:any){
    this.resetData();
    const tabLabel = event?.tab?.textLabel || event;
    
    if(tabLabel === "Address Grievance"){
      this.grievanceTable.tableHeaders['whomToSent'].name = 'Raised By Whom';
      this.grievanceTable.tableHeaders['editDelete'].name = 'Edit';
      this.getAllAddressGrievance();
    } else if(tabLabel === "Grievance"){
      this.grievanceTable.tableHeaders['whomToSent'].name = 'Whom To Sent';
      this.grievanceTable.tableHeaders['editDelete'].name = 'Edit / Delete';
      this.getAllGrievance();
    }
  }
  
  
  getAllGrievance(){
    this.selectedTabIndex = 'allGrievance';
    this.grievanceServicesService.getAllGrievanceList(this.selectedTabIndex).pipe( 
      map((data: any) =>
        data?.data.sort((a:any, b:any) => new Date(b.raisedDate).getTime() - new Date(a.raisedDate).getTime())
    )).subscribe({
      next: (value:any) => {
        if(value.length > 0){
          value.map( (data:any) => { 
            // if(Number(data.resolverUserId) === Number(this.getCompanyAndUsersData.loggedInUserId)) this.viewAddressGrievance = true;
            this.grievanceTable.tableData.push(this.prepareTableData(this.selectedTabIndex, data)); 
          });
        }
      },
      error:(err) => { 
      }
    });
  }
  
  
  getAllAddressGrievance(){
    this.selectedTabIndex = 'addressGrievance';   
    this.grievanceServicesService.getAllGrievanceList(this.selectedTabIndex).pipe( 
      map((data: any) =>
        data?.data.sort((a:any, b:any) => new Date(b.raisedDate).getTime() - new Date(a.raisedDate).getTime())
    )).subscribe({
      next: (value:any) => {
        if(value.length > 0) {
          value.map( (data:any) => {
            if( Number(data.resolverUserId) === Number(this.getCompanyAndUsersData.loggedInUserId)){
              this.grievanceTable.tableData.push(this.prepareTableData(this.selectedTabIndex, data));
            } 
          });  
        }
      },
      error:(err) => { 
      }
    });
  }
  
  
  resetData(){
    this.grievanceTable = {
      ...this.grievanceTable,
      tableData: []
    }
  }
  
  
  onAddGrievance(){
    const onAddGrievance = this.grievanceServicesService.onAddOrUpdateGrievanceModal({tabType: this.selectedTabIndex, modalData: ''});
    onAddGrievance.afterClosed().subscribe( (data) => {
      if(data.status) {
        this.toastr.success(data.message);
        this.grievanceTable.tableData.unshift(this.prepareTableData( this.selectedTabIndex, data.data));
      }
    });
  }
  
  
  prepareTableData(tabType:string, data:any){
    this.grievanceServicesService.statusType.map( (status:{key:string, value:string, count:number}) => {
      if(status.key === data.status){
        status.count++;
      }
    });
    
    return { 
      tabType: tabType,
      id: data?.id || null,
      grievanceType: this.grievanceServicesService.getGrevType(data.grievanceType),
      grievanceTypeKey: data.grievanceType,
      againstWhom: data.againstWhom,
      whomToSent: this.selectedTabIndex == 'allGrievance' ? data.whomToSent : data.raisedBy,
      raisedDate: String(data.raisedDate),
      resolvedDate: data.resolvedDate,
      status: data.status,
      priority: data.priority,
      reason: data.reason,
      commentFromReceiver: data.commentFromReceiver,
      commentDate: data.commentFromReceiver, 
      userId: data.userId, 
      companyId: data.companyId, 
      fiscalYear: data.fiscalYear, 
      year: data.year, 
      
      raisedBy: data.raisedBy,
      raisedEmailId: data.raisedEmailId,
      resolverUserId: data.resolverUserId,
      resolverEmailId: data.resolverEmailId,
      ifComment: data.commentFromReceiver ? true : false,
      ifStatusInProgress: data.status == 'IN_PROGRESS' ? true : false,
      ifStatusClosed: data.status == 'CLOSED' ? true : false,
    };
  }
  
}



